<template>
  <div class="d-flex justify-center mt-0">
    <v-btn
      v-show="currentCategory?.id !== firstCategory?.id"
      v-bind="useButtonStyle"
      class="mr-1"
      @click="onFirstCategorySelect()"
    >
      <v-icon :icon="mdiChevronDoubleLeft"/>
    </v-btn>

    <v-btn
      v-show="currentCategory?.id !== firstCategory?.id"
      v-bind="useButtonStyle"
      class="mr-1"
      @click="onPrevCategorySelect()"
    >
      <v-icon :icon="mdiChevronLeft"/>
    </v-btn>

    <v-btn
      variant="text"
      class="mx-1"
    >
      <strong>{{ currentCategory?.name }}</strong>
    </v-btn>

    <v-btn
      v-show="currentCategory?.id !== lastCategory?.id"
      v-bind="useButtonStyle"
      class="ml-1"
      @click="onNextCategorySelect()"
    >
      <v-icon :icon="mdiChevronRight"/>
    </v-btn>

    <v-btn
      v-show="currentCategory?.id !== lastCategory?.id"
      v-bind="useButtonStyle"
      class="ml-1"
      @click="onLastCategorySelect()"
    >
      <v-icon :icon="mdiChevronDoubleRight"/>
    </v-btn>
  </div>
</template>

<script setup>
import { inject, computed } from 'vue';
import { useRouter } from 'vue-router';
import { mdiChevronLeft, mdiChevronRight, mdiChevronDoubleLeft, mdiChevronDoubleRight } from '@mdi/js';
import {useButtonStyle} from "@/utils/appStyleHandler";

const router = useRouter();

const currentMissionPlanningId = inject('currentMissionPlanningId');
const currentScreenId = inject('currentScreenId');
const currentCategoryId = inject('currentCategoryId');
const currentConfiguration = inject('currentConfiguration');
const currentPointOfSale = inject('currentPointOfSale');

const categories = computed(() => {
  const categoryMap = currentConfiguration.value?.catalog?.category || {};
  const products = currentConfiguration.value?.catalog?.product || {};
  const statsIndicators = (currentPointOfSale.value?.statisticIndicators ? Object.values(currentPointOfSale.value?.statisticIndicators) : [])
  const productIds = statsIndicators.flat();
  const categoryIds = new Set(productIds.map(id => products[id]?.category?.id).filter(id => id !== undefined));
  return Object.values(categoryMap)
    .filter(cat => categoryIds.has(Number(cat.id)))
    .sort((a, b) =>
      a.name.localeCompare(b.name, undefined, { sensitivity: 'base' })
    );
});

const currentCategoryIndex = computed(() => {
  const index = categories.value.findIndex(c => c.id.toString() === currentCategoryId.value?.toString());
  return index !== -1 ? index : null;
});
const nextCategory = computed(() => {
  const nextIndex = currentCategoryIndex.value + 1;
  return nextIndex < categories.value.length ? categories.value[nextIndex] : null;
});
const prevCategory = computed(() => {
  const prevIndex = currentCategoryIndex.value - 1;
  return prevIndex >= 0 ? categories.value[prevIndex] : null;
});
const firstCategory = computed(() => categories.value?.[0] || {});
const lastCategory = computed(() => categories.value?.[categories.value.length - 1] || {});
const currentCategory = computed(() => Object.values(categories.value).filter((c) => c?.id?.toString() === currentCategoryId.value?.toString())[0] || {});

const onFirstCategorySelect = () => {
  goToQuestionnaireCategory(firstCategory.value?.id);
}

const onLastCategorySelect = () => {
  goToQuestionnaireCategory(lastCategory.value?.id);
}

const onPrevCategorySelect = () => {
  goToQuestionnaireCategory(prevCategory.value?.id);
}

const onNextCategorySelect = () => {
  goToQuestionnaireCategory(nextCategory.value?.id);
}

const goToQuestionnaireCategory = (catId) => {
  router.push({
    name: 'mission-planning-questionnaire-screen-category',
    params: {
      id: currentMissionPlanningId.value,
      screen_id: currentScreenId.value,
      category_id: catId
    },
  });
}
</script>